import { SHOW_APP_LOADER, HIDE_APP_LOADER, TOGGLE_GUEST_UPGRADE_MODAL } from '../action_types';
export const showAppLoader = () => {
    return { type: SHOW_APP_LOADER }
}
export const hideAppLoader = () => {
    return { type: HIDE_APP_LOADER }
}
export const toggleGuestUpgradeModal = (data) => {
    return { type: TOGGLE_GUEST_UPGRADE_MODAL, payload: data }
}


